/**
 * Cookie consent utility functions
 */

// Cookie consent status types
export const CONSENT_STATUS = {
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  PARTIAL: 'partial'
};

// Storage keys
const STORAGE_KEYS = {
  CONSENT: 'cookie-consent',
  PREFERENCES: 'cookie-preferences'
};

/**
 * Get current cookie consent status
 */
export const getConsentStatus = () => {
  return localStorage.getItem(STORAGE_KEYS.CONSENT);
};

/**
 * Get cookie preferences
 */
export const getPreferences = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.PREFERENCES);
    return data ? JSON.parse(data) : null;
  } catch (err) {
    return null;
  }
};

/**
 * Check if analytics cookies are allowed
 */
export const isAnalyticsAllowed = () => {
  const consent = getConsentStatus();
  return consent === CONSENT_STATUS.ACCEPTED;
};

/**
 * Save consent data to localStorage
 */
export const saveConsent = (status, preferences) => {
  const consentData = {
    status,
    preferences,
    timestamp: new Date().toISOString()
  };
  
  localStorage.setItem(STORAGE_KEYS.CONSENT, status);
  localStorage.setItem(STORAGE_KEYS.PREFERENCES, JSON.stringify(consentData));
  
  return consentData;
};

/**
 * Accept all cookies
 */
export const acceptAllCookies = () => {
  const preferences = { 
    essential: true, 
    analytics: true, 
    marketing: true 
  };
  return saveConsent(CONSENT_STATUS.ACCEPTED, preferences);
};

/**
 * Accept selected cookies
 */
export const acceptSelectedCookies = (preferences) => {
  const status = preferences.analytics ? CONSENT_STATUS.ACCEPTED : CONSENT_STATUS.PARTIAL;
  return saveConsent(status, preferences);
};

/**
 * Decline all optional cookies
 */
export const declineAllCookies = () => {
  const preferences = { 
    essential: true, 
    analytics: false, 
    marketing: false 
  };
  return saveConsent(CONSENT_STATUS.DECLINED, preferences);
};

/**
 * Check if consent banner should be shown
 */
export const shouldShowConsentBanner = () => {
  return !getConsentStatus();
};
